import { apiRequest } from '@/lib/api';
import type { AppointmentAttendanceHint, AppointmentAttendanceListData } from '@/types/dynamic-form';

function buildQuery(filters?: Record<string, string | number | undefined>) {
  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      params.append(key, String(value));
    });
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const instructorFormsApi = {
  listAppointmentAttendanceBookings: (
    formId: string,
    filters?: {
      page?: number;
      limit?: number;
      fieldId?: string;
      statusTab?: 'confirmed' | 'cancelled' | 'all';
      attendanceStatus?: 'pending' | 'attended' | 'not_attended';
      slotStartFrom?: string;
      slotStartTo?: string;
      search?: string;
    }
  ) =>
    apiRequest<{
      statusCode: number;
      message: string;
      data: AppointmentAttendanceListData;
    }>(
      `/api/instructor/forms/${encodeURIComponent(formId)}/appointment/bookings${buildQuery(filters)}`
    ),

  patchAppointmentAttendance: (
    formId: string,
    bookingId: string,
    body: { outcome: 'attended' | 'not_attended' }
  ) =>
    apiRequest<{
      statusCode: number;
      message: string;
      data: {
        booking: Record<string, unknown>;
        attendance: AppointmentAttendanceHint;
      };
    }>(
      `/api/instructor/forms/${encodeURIComponent(formId)}/appointment/bookings/${encodeURIComponent(bookingId)}/attendance`,
      { method: 'PATCH', body }
    ),
};
